import axiosInstance from '@/utils/api.js'

var state = {
  collectors: []
}

var getters = {
  COLLECTORS: (state) => {
    return state.collectors
  }
}

var mutations = {
  SET_COLLECTORS: (state, payload) => {
    state.collectors = payload
  }
}

var actions = {
  GET_COLLECTORS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/collectors')
    if (result.status === 200) {
      context.commit('SET_COLLECTORS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/collectors.js